import { ConfigTemplateInputProperty } from "PFTypes/config_template";
import { FilterConfigTemplateInputsFamily } from "PFTypes/filters_config";
import React from "react";

import {
  ArrayField,
  CheckboxField,
  InputField,
  NotSupportedField,
  SelectOneField
} from "./properties_fields";

type PropertyProps = {
  name: FilterConfigTemplateInputsFamily | "name";
  type: ConfigTemplateInputProperty["type"];
  options?: string[];
  items?: ConfigTemplateInputProperty["items"];
  fieldPrefix: string;
  required: boolean;
  disabled?: boolean;
  validate?: (value: string | number | boolean) => string | null;
};

export type PropertyFieldProps = {
  fieldName: string;
  label?: string;
} & Pick<PropertyProps, "options" | "items" | "required" | "type" | "disabled" | "validate">;

export const Property = ({
  name,
  type,
  options,
  items,
  fieldPrefix,
  required,
  disabled,
  validate
}: PropertyProps) => {
  const fieldName = `${fieldPrefix}.${name}`;

  const props: PropertyFieldProps = {
    fieldName,
    label: name,
    options,
    items,
    required,
    type,
    disabled,
    validate
  };

  const Component =
    {
      select_one: SelectOneField,
      string: InputField,
      number: InputField,
      checkbox: CheckboxField,
      array: ArrayField
    }[type] || NotSupportedField;

  return <Component {...props} />;
};
